
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Redirect,
  Link
} from "react-router-dom";
import Sidebar from './componants/Sidebar/Sidebar';
import Exam from './componants/Exam/Exam';
import Globalstates from './Context/Globalstates';
import Globalcontext from './Context/Globalcontext';
import { useContext } from 'react';
import Result from './componants/Result/Result';
import  Login  from './componants/Login/Login';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Signup from './componants/Signup/Signup';
import Myaccount from './componants/Myaccount/Myaccount';
import Serviceinfo from './componants/Serviceinfo/Serviceinfo';
import Plans from './componants/Plans/Plans';

function App() {
  const a = useContext(Globalcontext);
  return (
    <Globalstates>
      <Router basename="/studentiqtest">
        <div className="App">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/Dashboard" element={<Sidebar />} />
            <Route path="/test" element={<Sidebar />} />
            <Route path="/exam" element={<Exam />} />
            <Route path="/result" element={<Result />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/myaccount" element={<Myaccount />} />
            <Route path="/services" element={<Serviceinfo />} />
            <Route path="/plans" element={<Plans />} />
          </Routes>
        </div>
        <ToastContainer />
      </Router>
    </Globalstates>
  );
}

export default App;
